import { useTranslation } from 'react-i18next';

import { EMPTY_FIELD } from 'support/helpers/const/const';
import { formatDayAndTime } from 'support/helpers/dateTime/dateTime';
import { RelationshipV2 } from 'support/types';
import { Alert } from 'components/Display/Alert/Alert';
import { Translate } from 'components/Translate/Translate';

export const RelationshipDetailsBanner = ({
  relationship,
  pendingTasksCount,
}: {
  relationship: RelationshipV2;
  pendingTasksCount: number;
}) => {
  const { t } = useTranslation();

  switch (relationship.status) {
    case 'BLOCKED': {
      return (
        <Alert fullWidth withoutIcon severity="neutral">
          <Translate i18nKey="connections:relationshipDetails.header.alert.blocked.description" />
        </Alert>
      );
    }

    case 'GO_LIVE_DATE_SCHEDULED': {
      const goLiveDate = relationship.go_live_date ? formatDayAndTime(relationship.go_live_date) : EMPTY_FIELD;

      return (
        <Alert
          fullWidth
          withoutIcon
          severity="success"
          title={t('connections:relationshipDetails.header.alert.goLiveDateScheduled.title')}
        >
          <Translate
            i18nKey="connections:relationshipDetails.header.alert.goLiveDateScheduled.description"
            values={{ goLiveDate }}
          />
        </Alert>
      );
    }
    case 'GO_LIVE_DATE_PENDING':
      return (
        <Alert fullWidth withoutIcon severity="neutral">
          <Translate i18nKey="connections:relationshipDetails.header.alert.goLiveDatePending.description" />
        </Alert>
      );

    case 'ACTIVE':
      return (
        <Alert fullWidth severity="info" withoutIcon>
          <Translate i18nKey="connections:relationshipDetails.header.alert.active.description" />
        </Alert>
      );
    default: {
      if (pendingTasksCount === 0) {
        return null;
      }
      return (
        <Alert severity="info" fullWidth withoutIcon>
          {t('connections:relationshipDetails.pendingTasksBanner.description', { count: pendingTasksCount })}
        </Alert>
      );
    }
  }
};
